import $ from 'jquery';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';

gsap.registerPlugin(CSSPlugin);

import throttle from 'lodash.throttle';

import asideMenu from './modules/aside-menu';

import './modules/menu';
import './modules/overlay';
import './modules/sliders';
import './modules/input-file';
import toggle from './modules/toggle';
import initTabs from './modules/tabs';
import './modules/popup';

document.addEventListener('DOMContentLoaded', ()=>{
    asideMenu.init();
});

document.addEventListener('DOMContentLoaded', function () {
    $('[data-fancybox="gallery"]').fancybox({});
    $('.js-phone').inputmask({mask: "+7 (999) 999-99-99", showMaskOnHover: false });
    $('[data-toggle="init"]').each(function () {
        let button = $(this).find('[data-toggle="button"]');
        let area = $(this).find('[data-toggle="area"]');
        let text = Boolean(button.data('otext') || button.data('ctext'));
        new toggle(button, area, text);
    });
    let complexTabs = document.querySelectorAll('.tabs-container');
    if (complexTabs.length > 0) {
        initTabs('.tabs-container');
    }
});

/*document.addEventListener('DOMContentLoaded', () => {
    let popup = document.querySelector('.popup');
    window.modal = {};
    window.modal = new popupHelper(popup);
});*/

$(function() {
    var btn = $('.top-button');

    $(window).scroll(function() {
        if ($(window).scrollTop() > 500) {
            btn.addClass('top-button_visible');
        } else {
            btn.removeClass('top-button_visible');
        }
    });

    btn.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({scrollTop:0}, '500');
    });
});



